<template>
  <h1 ref="header"><slot/></h1>
</template>


<script>
export default {
  name: 'AppTitle',

  data: () => ({
    observer: null,
    controller: new AbortController(),
  }),

  mounted() {
    this.createObserver();
    addEventListener('resize', () => {
      this.$refs.header.style.removeProperty('font-size');
      this.createObserver();
    }, { signal: this.controller.signal });
  },

  beforeDestroy() {
    this.observer.disconnect();
    this.controller.abort();
  },

  methods: {
    createObserver() {
      const el = this.$refs.header;
      this.observer?.disconnect();
      this.observer = new ResizeObserver(([entry]) => {
        if (!el?.parentNode) return;
        let parentWidth = el.parentNode.clientWidth;
        const styles = getComputedStyle(el.parentNode);
        parentWidth -= parseFloat(styles.paddingLeft) + parseFloat(styles.paddingRight);

        const currentWidth = entry.contentRect.width;
        if (parentWidth >= currentWidth) return;
        const fontSize = getComputedStyle(el).getPropertyValue('font-size').slice(0, -2);
        const newFontSize = fontSize * (parentWidth / currentWidth);
        el.style.setProperty('font-size', `${newFontSize.toFixed(2)}px`);
      });
      this.observer.observe(el);
    },
  },
};
</script>


<style lang="scss" scoped>
h1 {
  margin: 0;
  font-weight: 500;
  text-transform: uppercase;
  font-family: Onder, Arial, Helvetica, sans-serif;
  font-size: clamp(8px, 1em, 1em);
  line-height: 1.4;
  width: max-content;
}
</style>